<template>
  <div class="card py-10 px-6">
    <Row>
      <Col md="3">
        <Picture
          :src="require('@/assets/illustration/edit_site.svg')"
          maxHeight="175px"
          contain
        />
      </Col>
      <Col class="align-self-center ml-7 px-0 py-0">
        <span class="d-block gray--text text--scale500 font-weight-medium text-paragraph-1 mb-2" v-text="lc.title" />
        <p class="gray--text text--scale500 text-paragraph-2" v-html="lc.description" />
        <Button
          class="mt-4"
          color="primary"
          :to="editSitePath"
          :label="lc.buttonLabel"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import { Button, Picture, Row, Col } from '@locaweb/design-system-vue'

export default {
  name: 'EditSiteCard',
  components: {
    Button,
    Picture,
    Row,
    Col
  },
  computed: {
    lc () {
      return this.$lc('site.components.editSiteCard')
    },
    editSitePath () {
      return { name: 'editorView' }
    }
  }
}
</script>

<style scoped>
.card {
  background-color: #EEE;
}

</style>
